import styled from '@emotion/styled'
import getSafeBottomSpacingValue from 'utils/getSafeBottomSpacing'

import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'

export const MainContentContainer = styled.div`
  &.--safari {
    padding-bottom: ${getSafeBottomSpacingValue({
      spacing: 0,
      isSafari: true
    })};
  }

  position: relative;
  z-index: 1;
  margin-top: ${minus(cssTheme.layout.spacing.s500)};
`

export const SideShadow = styled.div<{side: 'start' | 'end'}>`
  box-shadow: ${({side}) => (side === 'start' ? '-10px' : '10px')} 0px 8px 16px
    ${cssTheme.colors.background.neutral.primary};
  z-index: 1;
`

export const ResetSectionPadding = styled.div`
  margin-right: ${minus(cssTheme.layout.spacing.s500)};
  margin-left: ${minus(cssTheme.layout.spacing.s500)};
`

export const BoxSectionPadding = styled(ResetSectionPadding)`
  padding-left: ${cssTheme.layout.spacing.s400};
  padding-right: ${cssTheme.layout.spacing.s400};
`
